export enum EventRecordType {
    CallForService = 1,
    Incident = 2  
}

export const eventRecordTypeLabels: Record<EventRecordType, string> = {
    [EventRecordType.CallForService]: 'Call For Service',
    [EventRecordType.Incident]: 'Incident Report',
};

export const eventRecordTypeOptions = Object.values(EventRecordType)
    .filter((v): v is EventRecordType => typeof v === 'number')
    .map(v => ({ id: v, description: eventRecordTypeLabels[v] }));